import React from "react";
import { fileUrl } from "@/lib/api";

// If path is a full URL (seeded stock photos), use as-is. Otherwise proxy through backend.
export default function ImageThumb({ path, alt = "", className = "" }) {
  const src = !path ? "" : (path.startsWith("http") ? path : fileUrl(path));
  if (!src) {
    return (
      <div className={`bg-neutral-50 flex items-center justify-center ${className}`}>
        <span className="text-[0.6rem] tracking-[0.18em] uppercase text-neutral-300">No photo</span>
      </div>
    );
  }
  return (
    <img src={src} alt={alt} className={className} loading="lazy" />
  );
}
